import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import Reveal from '@/components/base/Reveal';
import PartnerPortrait from '@/components/feature/PartnerPortrait';
import { partners } from '@/mocks/site';

export default function PartnersSection() {
  return (
    <section className="paper-texture border-t border-background-200 bg-background-100 py-20 md:py-28 lg:py-32">
      <Container>
        <SectionLabel index="04" label="People" />
        <div className="mt-12 flex flex-col gap-6 md:mt-16 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <h2 className="max-w-2xl font-heading text-4xl font-light leading-[1.05] tracking-[-0.02em] md:text-5xl">
              Experience behind every decision.
            </h2>
          </Reveal>
          <Link to="/people" className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:text-primary-500">
            <i className="ri-arrow-right-line" /> <span className="ed-link">All partners</span>
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-x-4 gap-y-12 md:gap-x-6 lg:grid-cols-4">
          {partners.map((p, i) => (
            <Reveal key={p.slug} delay={i * 80}>
              <Link to={`/people#${p.slug}`} className="group block cursor-pointer">
                <PartnerPortrait partner={p} variant={i} />
                <div className="mt-5 border-t border-background-300/70 pt-4">
                  <h3 className="text-base font-normal text-foreground-950 group-hover:text-primary-500 md:text-xl">{p.name}</h3>
                  <p className="mt-1 font-label text-[10px] uppercase tracking-[0.12em] text-foreground-600 md:text-[11px]">{p.role} — {p.focus}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}